// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-item-vert-center-solid';

export const Component = () => (
  <path d='M21.63 15.183v3.927c0 .431-.143.767-.43 1.054a1.408 1.408 0 0 1-1.055.431h-7.327v3.449c0 .335-.191.479-.527.479-.335 0-.479-.144-.479-.48v-3.448H4.486a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 3 19.11v-3.927c0-.431.144-.767.431-1.054a1.58 1.58 0 0 1 1.054-.383h7.327v-2.97H7.407a1.41 1.41 0 0 1-1.054-.43 1.378 1.378 0 0 1-.43-1.006V5.412c0-.43.143-.766.43-1.053a1.408 1.408 0 0 1 1.054-.432h4.407V.48c0-.335.143-.479.478-.479.336 0 .527.144.527.479v3.448h4.406c.431 0 .767.144 1.054.432.288.287.431.622.431 1.053V9.34c0 .383-.143.719-.43 1.005a1.411 1.411 0 0 1-1.055.432h-4.406v2.97h7.327c.432 0 .767.143 1.054.382.288.287.431.623.431 1.054Z' />
);

export const viewBox = '0 0 25 25';
